


















































import { TournamentEntity } from '@/api/tournament'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import TeamDetailReview from '../TeamDetailReview'

@Component({
  components: {
    TeamDetailReview
  }
})
export default class extends Vue {
  accepted: boolean = false

  @Prop({ type: String, required: true }) teamName!: string
  @Prop({ type: Object, required: true }) tournament!: TournamentEntity
  @Prop({ type: Boolean, default: false }) loading!: boolean

  @Emit('back')
  back() {}

  @Emit('submit')
  submit() {}
}
